import styled from "@emotion/styled";
import rem from "../../utils/rem/rem";

export const TableWrapper =  styled.div`
  padding: ${rem(16)} ${rem(16)} ${rem(16)} ${rem(16)};
`;

export const SubTextWrapper = styled.div`
  padding: ${rem(16)} ${rem(16)} ${rem(16)} ${rem(16)};
  border-radius: 30px;
  justify-content: space-between;
  flex-direction: row;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colors.gray100};
`;

export const HeaderText = styled.div`
  padding: ${rem(16)} ${rem(16)} ${rem(16)} ${rem(16)};
  font-family: 'Open Sans';
  font-weight: 600;
  font-size: ${rem(14)};
  color: ${({ theme }) => theme.colors.gray900};
  background-color: ${({ theme }) => theme.colors.gray100};
  display: flex;
  align-items: center;
`;

export const ExportButtonWrapper = styled.div`
  display: flex;
  padding-top: ${rem(16)};
  justify-content: flex-end;
`;